import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { RoleList } from './role-list';
import { RolesCreate } from './role-create';
import { RolesEdit } from './role-edit';
import { RoleDetails } from './role-detail';
import { Helmet } from 'react-helmet';

export const Role: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Role</title>
      </Helmet>
      <Routes>
        <Route path="*" element={<RoleList />} />
        <Route path="create" element={<RolesCreate />} />
        <Route path="edit/:roleId" element={<RolesEdit />} />
        <Route path="detail/:roleId" element={<RoleDetails />} />
      </Routes>
    </>
  );
};
